<template>
  <v-dialog 
  :value="value" 
  @input="$emit('input')" 
  transition="fade-transition" 
    persistent
  scrollable 
  width="1000px">
    <v-card>
      <v-card-title class="card-title-background">
        Edit Content Script for @{{item ? item.userHandle : ''}}
          <v-spacer></v-spacer>
          <v-btn icon @click="close">
            <v-icon>close</v-icon>
          </v-btn>
      </v-card-title>
      <v-card-text class="bg-white" style="height: 700px;margin-top:20px;">
        <v-row>
          <v-col cols='12'>
            <v-col class="text-right" cols='12'>
              <v-btn small color='primary' @click='restoreTemplate'>Load Default</v-btn>
            </v-col>
          </v-col>
        </v-row>
        <sun-editor
        style='height:650px;'
        :content='editContent'
        @contentChanged="changeContent">
        </sun-editor>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red" id="close" text @click.native="close()">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green" text @click="save()" :disabled="!editContent">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import SunEditor from '../../../editor/sunEditor'
import utils from '@/utils'
import creatorConceptTemplate from './template';
export default {
  name: 'ContentScriptEditDialog',
  components: {
    SunEditor
  },
  props: {
    value: Boolean,
    item: Object
  },
  data () {
    return {
      utils: utils.func,
      editContent: ''
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        // this.currentMode = 'detail'
        this.editContent = ''
        if (this.item) {
          if (this.item.contentScripts) {
            this.editContent = this.item.contentScripts
          }
        }
      }
    }
  },
  methods: {
    save() {
      this.editContent = this.editContent.replaceAll('background-color:transparent', '')
      this.item.contentScripts = this.editContent
      this.$emit('saveClicked', this.item)
      this.$emit('input')
    },
    changeContent(content) {
      this.editContent = content
    },
    async restoreTemplate() {
      this.editContent = creatorConceptTemplate.templateContents
    },
    async close() {
      const result = await this.$swal({
        title: 'Leave without saving changes?',
        text: 'Your changes may not be saved.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Leave',
        cancelButtonText: 'Stay'
      })

      if (!result.value) {
        return
      }

      this.$emit('input');
    }
  }
}
</script>



// WEBPACK FOOTER //
// ContentScriptEditDialog.vue?1e846bfc